<script>
  // Bindable list of 'YYYY-MM-DD' date strings — backs Schedule#schedule_exclusions/inclusions
  // (each entry becomes a { date: '...' } nested attribute; see schedule_editor.svelte).
  let { value = $bindable([]), label } = $props()

  let pending = $state('')

  const add = () => {
    if (!pending || value.includes(pending)) return
    value = [...value, pending].sort()
    pending = ''
  }

  const remove = (date) => {
    value = value.filter((existing) => existing !== date)
  }
</script>

<fieldset class="fieldset">
  {#if label}<legend class="fieldset-legend">{label}</legend>{/if}

  <div class="flex gap-2">
    <input type="date" bind:value={pending} class="input input-sm" />
    <button type="button" class="btn btn-sm" onclick={add} disabled={!pending}>Add date</button>
  </div>

  {#if value.length > 0}
    <div class="flex flex-wrap gap-2 mt-2">
      {#each value as date (date)}
        <span class="badge badge-outline gap-1">
          {date}
          <button type="button" aria-label="Remove {date}" onclick={() => remove(date)}>✕</button>
        </span>
      {/each}
    </div>
  {/if}
</fieldset>
